module.exports = __webpack_public_path__ + "img/code01.176e3890.jpg";